import React, { useState, useCallback } from 'react';
import proptypes from 'prop-types';
const { objectOf } = proptypes;
import { useConfiguratorStore, useProductDataStore } from '../../store';
import { useDesignStore } from '../../store/design/context';
import { getLocalizerZipCode } from '../../utils/fulfillment-utils';
import { choiceShape, optionShape } from '../types';

const customCarouselBreakpoints = {
  sm: {
    slidesPerView: 3,
    slidesPerGroup: 3,
    spaceBetween: 7,
  },
  md: {
    slidesPerView: (
      typeof window !== 'undefined'
      && window.matchMedia('(orientation: landscape)').matches
    )
      ? 3
      : 4,
    slidesPerGroup: 4,
    spaceBetween: 7,
  },
  lg: {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 7,
  },
  xl: {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 7,
  }
};

const UpdatedComponent = (OriginalComponent) => {
  function NewComponent(props) {
    const { option, choices } = props;
    const zipCode = getLocalizerZipCode();
    const [quickView, setQuickView] = useState({
      itemId: null,
      isOpen: false,
    });

    const metadata = useConfiguratorStore((state) => state.configurator.metadata);
    const bundles = useDesignStore((state) => state.bundles.data);
    const productData = useProductDataStore((state) => state.productData);

    const handleQuickView = useCallback(({ itemId }) => {
      setQuickView({
        itemId,
        isOpen: true,
      });
    }, []);

    return (
      <>
        <OriginalComponent
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
          bundles={bundles}
          option={option}
          choices={choices}
          customCarouselBreakpoints={customCarouselBreakpoints}
          handleQuickView={handleQuickView}
          metadata={metadata}
          productData={productData}
          quickView={quickView}
          setQuickView={setQuickView}
          zipCode={zipCode}
        />
      </>
    );
  }

  NewComponent.propTypes = {
    option: optionShape.isRequired,
    choices: objectOf(choiceShape)
  };

  NewComponent.defaultProps = {
    choices: []
  };

  return NewComponent;
};

export default UpdatedComponent;
